import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/ComboBox/sgds-combo-box-option";
import { register } from "../../utils/ce-registry";

register("sgds-combo-box-option", Component);

export default createComponent({
  react: React,
  tagName: "sgds-combo-box-option",
  elementClass: Component,
  events: {}
});
